module.exports = __webpack_public_path__ + "static/img/摩尔线程 MTT KUAE 智算中心全栈解决方案.7f806659.png";